import React from 'react';
import styles from './WizardAgreementList.module.scss';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import WizardCheckbox from '../WizardCheckbox/WizardCheckbox';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.AGREEMENT_LIST }>;
}

const WizardAgreementList: React.FC<Props> = ({ item }) => {
	return (
		<div className={styles.wrapper}>
			{item.children.map(child => (
				<WizardCheckbox item={child} key={child.id} />
			))}
		</div>
	);
};

export default WizardAgreementList;
